import * as React from "react"
import { graphql } from "gatsby"
import { StaticImage } from "gatsby-plugin-image"
import * as styles from '@/styles/pages/about.module.scss';

import Layout from "../components/layout"
import Seo from "../components/seo"

const About = ({ data }) => (
  <Layout>
    <Seo title="自己紹介" />
    <div className={styles.container}>
      <h1>自己紹介</h1>
      <section id='intro' className={styles.intro}>
        <div className={styles.boke0}>
          <StaticImage
            src="../images/boke0.svg"
            width={160}
            height={160}
            quality={95}
            alt="木瓜丸印"
          />
        </div>
        <div>
          <p style={{
            fontSize: '1.2rem'
          }}><ruby>木瓜丸<rt>ぼけまる</rt></ruby>です。</p>
          <p>HTML5が勧告されたあたりからWeb開発の世界に飛び込み、10年ほど自己中に開発活動をしています。UK HardcoreやFuture Coreみたいなやかましい音楽を好んで聞いています。</p>
          <p>最近バイクの免許取ろうとして頑張っています。ツーリング行きたい</p>
        </div>
      </section>
      <section id='works' className={styles.works}>
        <h2>作ったもの</h2>
        <p>過去に個人で作ったプロダクトなどをまとめました。</p>
        <div className={styles.worksList}>
        { data.site.siteMetadata.works.map(work => (
          <div className={styles.item}>
            <h3 className={styles.title}>{ work.title }</h3>
            <p className={styles.description}>{ work.description }</p>
            <a className={styles.link} href={ work.url }>Link</a>
          </div>
        )) }
        </div>
      </section>
    </div>
  </Layout>
)

export const pageQuery = graphql`
  query {
    site {
      siteMetadata {
        works {
          title
          url
          description
        }
      }
    }
  }
`

export default About
